<template>
  <div v-if="preloadAdsShow" class="preLoadAds">
    <HCacheImage v-for="eachAd in adData" :src="eachAd['Icon']" :key="adData['Icon']" width="1px" height="1px"/>
  </div>
  <div class="parentDiv" :class="{homeFill: HNewGameUIConfig.newGameUIType !== 4}"
       :style="{backgroundColor: HNewGameUIConfig.newGameUIType === 0 ? '#fff' : undefined}">
    <div ref="topContainerRef"
         :class="{ pcHomeTopContents: isDesktop && [1,2,3,4].includes(HNewGameUIConfig.newGameUIType) }"
         :style="{flexShrink:0, backgroundColor: HNewGameUIConfig.newGameUIType===0 ? 'var(--ct-main-color-bg)' : undefined}">
      <HDownloadBar v-if="isShowTopDownDiv" showClose @close="clickTopCloseDown"/>
      <div v-if="HNewGameUIConfig.newGameUIType === 0" class="topLogoServiceDiv">
        <img :src="logo" height="33px;" alt="">
        <div style="flex:1"/>
        <div @click="openService"
             style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
          <van-badge :content="noRedMsgCount" :show-zero="false">
            <img :src="iconService" width="28px" height="28px" alt="" style="margin-right: 3px;">
          </van-badge>
          <div :style="hcf.getTextStyle({
              addSize:-1,color:'main',marginBottom:5,
            })">客服
          </div>
        </div>
      </div>
      <MGHomeMiddle :bannerData="bannerData" :openService="openService" :noRedMsgCount="noRedMsgCount"
                    :noticeList="noticeList" style="margin-bottom:8px;"/>
    </div>
    <div v-if="HNewGameUIConfig.newGameUIType === 4" :style="{
      backgroundImage:`url(${jmttFlagBg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'left',
      width:'100px',
      color:'white',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      marginTop:'10px',
      fontSize:'16px',
    }">
      官方游戏
    </div>
    <HomeBottomGameArea v-if="isShowBottomDiv" :bottomContainerHeight="bottomContainerHeight"
                        :fillParent="HNewGameUIConfig.newGameUIType !== 4"/>
    <div v-if="HNewGameUIConfig.newGameUIType === 4"
         style="width:100%;height:3px;background-color: #eee;margin:10px 0;"/>
    <div v-if="HNewGameUIConfig.newGameUIType === 4" :style="{
      backgroundImage:`url(${jmttFlagBg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'left',
      width:'100px',
      color:'white',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      fontSize:'16px',
    }">
      合作游戏
    </div>
    <div v-if="HNewGameUIConfig.newGameUIType === 4" :style="{
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px 10px 0 10px',
    alignItems: 'center',
    width:'100%',
    justifyContent:'center',
  }">
      <div @click="clickHeZuoGameItem(eachItem)" v-for="(eachItem,index) in heZuoGameList" :key="index" :style="{
          marginBottom:'7px',width:eachHeZuoImgWidth,position:'relative'
        }">
        <HCacheImage :src="eachItem['Icon']" :width="eachHeZuoImgWidth"/>
        <div v-if="eachItem['Status'] === 1"
             style="display:flex;align-items: center;justify-content:center;width:100%;background-color:#000a;height:100%;position: absolute;top:0;left:0;">
          <div :style="hcf.getTextStyle({
                  color:'white',addSize:1,fontWeight:'bold'
              })">
            维护中
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-dialog v-model:show="showAdModal" :show-confirm-button="false"
              :style="{backgroundColor:'#0000', marginTop: HNewGameUIConfig.newGameUIType!==0 ? '40px' : ''}">
    <div style="display: flex;flex-direction: column;padding-top:70px;">
      <HSwiper :data="adData" height="300px" :indicatorBelow="true" :noRadius="true" @item-click="showAdModal=false"/>
      <div @click="closeBtn" class="closeBtn">
        <van-icon name="cross" size="25px" color="#fff"/>
      </div>
    </div>
  </van-dialog>
</template>


<script setup>
  import {emitter, hcf, kRelease} from "@/components/utils/HComFunctions.js";
  import logo from "@/assets/icons/replaces/logo_slogon.png"
  import {onMounted} from "vue";
  import HSwiper from "@/components/utils/HSwiper.vue";
  import MGHomeMiddle from "@/components/pages/home/MGHomeMiddle.vue";
  import HomeBottomGameArea from "@/components/pages/home/HomeBottomGameArea.vue";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {useResponsive} from "@/hooks/useResponsive.js";
  const {isDesktop} = useResponsive();

  import HDownloadBar from "@/components/utils/HDownloadBar.vue";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {showToast} from "vant";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useClickModal} from "@/hooks/useClickModal.js";
  const clickModal = useClickModal();
  let useComApi = useHComApi();
  const iconService = hcf.getNewGameUIIcon("service.png");

  const jmttFlagBg = hcf.getNewGameUIIcon("flag_gfyx.png");

  let bannerData = useComApi.homeBannerList;
  let adData = useComApi.homeAdList;
  let noticeList = useComApi.homeNoticeList;
  const showAdModal = ref(false);
  //计算底部的区域应该有多高
  const isShowBottomDiv = ref(false);
  const topContainerRef = ref(null);
  const bottomContainerHeight = ref(0.0);

  const noRedMsgCount = ref(0);

  //预先加载ads图
  const preloadAdsShow = ref(true);
  let preAdTimer = null;
  //顶部下载: 带 smd=1(牢记域名场景)时, 顶部下载条一律隐藏
  const isShowTopDownDiv = ref(hdi.smd ? false : (hdi.fsd ? true : (HNewGameUIConfig.newGameUIType === 0 ? (!hdi.h2d && !hdi.isRunDesktop) : false)));

  //合作游戏列表
  const heZuoGameList = ref([]);
  const eachHeZuoImgWidth = ref(0);

  function openService() {
    noRedMsgCount.value = 0;
    useComApi.openService();
  }

  function clickHeZuoGameItem(itemInfo){
    if (itemInfo["Status"] === 1) {
      showToast("游戏维护中,请稍后再来吧");
    } else {
      if(itemInfo["ClickType"] === 2){
        clickModal.onClick(itemInfo);
      }else{
        clickModal.onClick({
              ClickType: itemInfo["ClickType"],
              ClickParam: {
                "name": itemInfo["Title"],
                "paras": itemInfo["ClickParam"],
                "leaveArgument": itemInfo["leaveArgument"],
              }
            }
        );
      }
    }
  }
  function clickTopCloseDown() {
    isShowTopDownDiv.value = false;
    bottomContainerHeight.value = bottomContainerHeight.value + 60;
  }

  onMounted(() => {
    emitter.on("PING_PONG_EVENT_NO_RED_MSG", (num) => {
      noRedMsgCount.value = num;
    });
    //合作游戏
    if (HNewGameUIConfig.newGameUIType === 4) {
      eachHeZuoImgWidth.value = (window.innerWidth - 24) / 3;
      useHHttp().request("/qp/game/lobby/jump", (resp) => {
        heZuoGameList.value = resp["ItemList"] ?? [];
      });
    }
    if (HNewGameUIConfig.newGameUIType === 4) {
      bottomContainerHeight.value = 250;
    } else {
      bottomContainerHeight.value = window.innerHeight - topContainerRef.value?.offsetHeight;
      bottomContainerHeight.value -= HNewGameUIConfig.newGameUIType === 0 ? 140 : 110;//减去底部bottom的高度带来的影响
    }
    if (bottomContainerHeight.value !== 0 && !isNaN(bottomContainerHeight.value)) {
      isShowBottomDiv.value = true;
    }
    if (adData.value.length > 0) {
      preloadAdsShow.value = true;
      // if (kRelease) {
        if (preAdTimer) {
          clearTimeout(preAdTimer);
          preAdTimer = null;
        }
        preAdTimer = setTimeout(() => {
          preloadAdsShow.value = false;
          showAdModal.value = true;
        }, 1500);
      // }
    }
  });

  onUnmounted(() => {
    if (preAdTimer) {
      clearTimeout(preAdTimer);
      preAdTimer = null;
    }
  });

  function closeBtn() {
    showAdModal.value = false;

    if(useComApi.downloadDomainList.value.length>0){
      if(hdi.smd){
        emitter.emit("DOWNLOAD_MODAL_VISIBLE",{"visible":true,dList:useComApi.downloadDomainList.value});
      }
    }
  }
</script>


<style scoped>
  .ignore-topDownDiv {
    display: flex;
    flex-direction: Row;
    height: 60px;
    width: 100%;
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(to right, #FFF1C7, #FEF3E1);
  }

  .closeBtn {
    margin-top: 16px;
    margin-left: calc(50% - 15px);
    background-color: #666;
    border-radius: 35px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .parentDiv {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: var(--ct-main-color-bg);
  }

  /* 永利(type0)首页: 撑满一屏, 顶部自然高度 + 游戏区 flex 填充剩余并内部滚动,
     不再依赖 JS 测量的 px 高度, 整页正好一屏不溢出, 顶部固定不被拖走。
     必须用 height(确定高度), 否则下层 flex:1 / 百分比高度解析为 auto, 列就不滚、整页又会溢出。 */
  .homeFill {
    /* 撑满一屏(所有非 type4): 顶部固定 + 游戏区 flex 填充内部滚,
       避免整个首页内容在容器里滚动(非游戏区上滑被拖走)。白底只 type0 由内联样式给。 */
    height: 100%;
  }

  .topLogoServiceDiv {
    padding: 10px 10px;
    display: flex;
    align-items: center;
  }

  .preLoadAds {
    position: fixed;
    top: -50px;
    left: -50px;
  }

  /* 桌面: 收紧顶部 logo/客服 行, 让 logo 贴近顶部、banner 贴近 logo。
     ① padding 从 vw(~38px) 拉回真实 px;
     ② 该行内 van-badge 包裹层无显式 font-size, 会继承被 vw 放大的 font-size(~57px),
        使 inline 客服图标坐在 92px 行盒上, 把整行撑到 108px —— 这里复位字号/行高并让
        badge 图标不撑行高, 行高回到图标本身高度。 */
  @media (min-width: 1024px) {
    .topLogoServiceDiv {
      padding: 6px 16px;
      font-size: 14px;
      line-height: normal;
    }
    .topLogoServiceDiv .van-badge__wrapper {
      line-height: 0;
    }
    /* 广告弹窗关闭按钮: <style> 里的 35px 被转 vw(桌面放大到 ~112px 的大圆), 拉回真实 px */
    .closeBtn {
      width: 35px;
      height: 35px;
      border-radius: 35px;
      margin-top: 16px;
      margin-left: calc(50% - 17.5px);
    }

    /* 桌面(非 main 包网): 顶部容器改 display:contents, 让其子节点(banner + 头部块)直接成为
       更高的 homeFill 的子级 —— 这样头部块的包含块变为整页高的 homeFill, 它 position:sticky
       才能在整个游戏列表滚动期间一直吸顶(否则被短短的顶部容器包含块限制, 一滚就脱离)。
       banner 仍是普通流子节点, 照常随滚动移走。 */
    .pcHomeTopContents {
      display: contents;
    }
  }
</style>
